import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages an info drawer triggered by a button block.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class InfoDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('info-drawer-component')) {
  customElements.define('info-drawer-component', InfoDrawerComponent);
}
